import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SteveProvider } from './state/SteveProvider';
// Les @font-face d'abord : la feuille est générée par `npm run fonts` et
// entre dans le bundle, donc son URL porte un hash — aucune ancienne version
// ne peut rester en cache et priver un skin de sa police.
import './styles/fonts.css';
import './styles/global.css';

/** Le morceau est servi depuis la même origine : sinon le mixeur serait muet. */
const AUDIO_SRC = `${import.meta.env.BASE_URL}steve.mp3`;

const container = document.getElementById('root');
if (!container) throw new Error('Le bac est introuvable : #root manque dans index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <SteveProvider audioSrc={AUDIO_SRC}>
        <App />
      </SteveProvider>
    </ErrorBoundary>
  </StrictMode>,
);
